module.exports = __webpack_public_path__ + "static/img/icon-line-svg.43e6d9d7.svg";